import React from "react";
import "../../screening-test/index.css";
import arrowImage from "../../../../assets/arrow.png";
import axios from "axios";
import resultImageG01 from "../../../../assets/FlatChartG01.svg";
import resultImageG02 from "../../../../assets/FlatChartG02.svg";
import resultImageO01 from "../../../../assets/FlatChartO01.svg";
import resultImageO02 from "../../../../assets/FlatChartO02.svg";
import resultImageR01 from "../../../../assets/FlatChartR01.svg";
import resultImageR02 from "../../../../assets/FlatChartR02.svg";

const faQuestions = require("../../../../utils/adhd4TestQuestionsFa.js");

class Adhd4 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      accessType: "User",
      scoboResult: null,
      autismBackground: "",
      autismDiagnosis: "",
      childAge: 0,
      userId: 0,
      questionsCounter: 0,
      questionsToShow: [],
      questionsSelectionByAge: [0],
      previousCount: 0,
      questionNumber: 0,
      questionsTotalNumber: 18,
      questions: {},
      screeningAnswer: [],
      screeningbooking: false,
      execute: false,
      results: {},
      finishedAnswering: false,
      resultNumber: 0,
      resultsSubscalesText: [
        "بیش فعالی",
        "نقص توجه",
        "درصد کل",
      ],
      countryCode: "IR", // this.props.languageInput,
      testAnswersOptions: [],
      testResultsText: [],
      isLoaded: false,
      pictureSelector: "",
    };
  }

  componentDidMount = async () => {

    this.setState({ questionsToShow: [...faQuestions] });

    const response = await axios.post(
      "https://request.kidiar.com/evaluation/request",
      { testName: "ADHD4" },
      { headers: { "x-access-token": localStorage.getItem("token") } }
    );
    if (response.data.status == 0) {
      window.location.href = "/fa/panel/evaluations/list?test=ADHD4"; // It could be changes to show some message to user
    }
    this.setState({ userId: response.data.audienceId });
    this.setState({ accessType: response.data.access });
    var receivedAge = response.data.age;

    this.setState({ childAge: receivedAge });

  };

  screeningAnswerHandler = (value) => {
    this.state.questions[this.state.questionsCounter] = value;
    console.log(this.state.questions);

    if (this.state.previousCount > 0) {
      this.setState({ previousCount: this.state.previousCount - 1 });
    }

    if (this.state.questionsCounter == 0 && value == 1) {
      this.questionChildNoSpeak();
    }
    if (this.state.questionsCounter != this.state.questionsTotalNumber-1) {
      this.setState({ questionsCounter: this.state.questionsCounter + 1 });
    } else {
      this.setState({ finishedAnswering: true });
      this.sendAnsweredQuestions();
    }
  };

  previousQuestionNumberHandler = () => {
    if (this.state.questionsCounter > 0) {
      this.setState({ questionsCounter: this.state.questionsCounter - 1 });
      this.setState({ previousCount: this.state.previousCount + 1 });
    }
  };

  nextQuestionNumberHandler = () => {
    if (this.state.previousCount > 0) {
      this.setState({ questionsCounter: this.state.questionsCounter + 1 });
      this.setState({ previousCount: this.state.previousCount - 1 });
    }
  };

  sendAnsweredQuestions = async () => {
    const results = await axios.post(
      "https://request.kidiar.com/evaluation/evaluate",
      {
        audienceId: this.state.userId,
        age: this.state.childAge, // 0, 1, 2, 3
        sex: this.state.gender,
        hasAutism: this.state.autismBackground,
        diagAutism: this.state.autismDiagnosis,
        questions: Object.keys(this.state.questions),
        answers: Object.values(this.state.questions),
        test: "ADHD4",
      },
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );
    console.log("server answer is: ", results.data);
    this.setState({ scoboResult: results.data.result });
  };

  render() {
    if (this.state.scoboResult != null) {
      if (this.state.scoboResult.Result == 1) {
        this.setState({ pictureSelector: resultImageG02 });
      }
      if (this.state.scoboResult.Result == 2) {
        this.setState({ pictureSelector: resultImageO02 });
      }
      if (this.state.scoboResult.Result == 3) {
        this.setState({ pictureSelector: resultImageR02 });
      }

      return (
        <div className="result-page">
          <div className="result-page-container">
            <div className="result-page-right-wrapper">
              {this.state.scoboResult.Result == 1 && (
                <img
                  src={this.state.pictureSelector}
                  className="result-answer"
                ></img>
              )}
              {this.state.scoboResult.Result == 2 && (
                <img src={resultImageO02} className="result-answer"></img>
              )}
              {this.state.scoboResult.Result == 3 && (
                <img src={resultImageR02} className="result-answer"></img>
              )}
              {this.state.scoboResult.Result == 4 && (
                <img src={resultImageR02} className="result-answer"></img>
              )}
            </div>
            <div className="result-page-left-wrapper">
              {this.state.scoboResult.Percentiles.map((subCount, i) => (
                <div className="d-flex w-100" key={i}>
                  <div
                    className="d-flex align-items-center font-11"
                    style={{
                      width: "20%",
                      height: "30px",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      marginBottom: "5px",
                    }}
                  >
                    <p>{this.state.resultsSubscalesText[i]}</p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      position: "relative",
                      width: "80%",
                      height: "30px",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      marginBottom: "5px",
                    }}
                  >
                    {subCount > 95 && (
                      <div
                        style={{
                          position: "absolute",
                          top: "0px",
                          left: "0%",
                          width: subCount + "%",
                          height: "30px",
                          background: "red",
                        }}
                      ></div>
                    )}
                    {subCount > 85 &&
                      subCount <= 95 && (
                        <div
                          style={{
                            position: "absolute",
                            top: "0px",
                            left: "0%",
                            width: subCount + "%",
                            height: "30px",
                            background: "#e86e34",
                          }}
                        ></div>
                      )}
                    {subCount <= 85 && (
                      <div
                        style={{
                          position: "absolute",
                          top: "0px",
                          left: "0%",
                          width: subCount + "%",
                          height: "30px",
                          background: "#8dc63f",
                        }}
                      ></div>
                    )}
                    <div
                      style={{
                        position: "absolute",
                        top: "7px",
                        left: "2%",
                        width: "12px",
                        height: "12px",
                        borderStyle: "solid",
                        borderWidth: "2px",
                        borderRadius: "20px",
                        borderColor: "black",
                      }}
                    ></div>
                    <div
                      style={{
                        position: "absolute",
                        top: "7px",
                        left: "9.7%",
                        width: "12px",
                        height: "12px",
                        borderStyle: "solid",
                        borderWidth: "2px",
                        borderRadius: "20px",
                        borderColor: "black",
                      }}
                    ></div>
                    <div
                      style={{
                        position: "absolute",
                        top: "7px",
                        left: "17.3%",
                        width: "12px",
                        height: "12px",
                        borderStyle: "solid",
                        borderWidth: "2px",
                        borderRadius: "20px",
                        borderColor: "black",
                      }}
                    ></div>
                    <div
                      style={{
                        position: "absolute",
                        top: "7px",
                        left: "25%",
                        width: "12px",
                        height: "12px",
                        borderStyle: "solid",
                        borderWidth: "2px",
                        borderRadius: "20px",
                        borderColor: "black",
                      }}
                    ></div>
                    <div
                      style={{
                        position: "absolute",
                        top: "7px",
                        left: "32.7%",
                        width: "12px",
                        height: "12px",
                        borderStyle: "solid",
                        borderWidth: "2px",
                        borderRadius: "20px",
                        borderColor: "black",
                      }}
                    ></div>
                    <div
                      style={{
                        position: "absolute",
                        top: "7px",
                        left: "40.3%",
                        width: "12px",
                        height: "12px",
                        borderStyle: "solid",
                        borderWidth: "2px",
                        borderRadius: "20px",
                        borderColor: "black",
                      }}
                    ></div>
                    <div
                      style={{
                        position: "absolute",
                        top: "7px",
                        left: "48%",
                        width: "12px",
                        height: "12px",
                        borderStyle: "solid",
                        borderWidth: "2px",
                        borderRadius: "20px",
                        borderColor: "black",
                      }}
                    ></div>
                    <div
                      style={{
                        position: "absolute",
                        top: "7px",
                        left: "55.7%",
                        width: "12px",
                        height: "12px",
                        borderStyle: "solid",
                        borderWidth: "2px",
                        borderRadius: "20px",
                        borderColor: "black",
                      }}
                    ></div>
                    <div
                      style={{
                        position: "absolute",
                        top: "7px",
                        left: "63.3%",
                        width: "12px",
                        height: "12px",
                        borderStyle: "solid",
                        borderWidth: "2px",
                        borderRadius: "20px",
                        borderColor: "black",
                      }}
                    ></div>
                    <div
                      style={{
                        position: "absolute",
                        top: "7px",
                        left: "71%",
                        width: "12px",
                        height: "12px",
                        borderStyle: "solid",
                        borderWidth: "2px",
                        borderRadius: "20px",
                        borderColor: "black",
                      }}
                    ></div>
                    <div
                      style={{
                        position: "absolute",
                        top: "7px",
                        left: "78.6%",
                        width: "12px",
                        height: "12px",
                        borderStyle: "solid",
                        borderWidth: "2px",
                        borderRadius: "20px",
                        borderColor: "black",
                      }}
                    ></div>
                    <div
                      style={{
                        position: "absolute",
                        top: "7px",
                        left: "86.3%",
                        width: "12px",
                        height: "12px",
                        borderStyle: "solid",
                        borderWidth: "2px",
                        borderRadius: "20px",
                        borderColor: "black",
                      }}
                    ></div>
                    <div
                      style={{
                        position: "absolute",
                        top: "7px",
                        left: "94%",
                        width: "12px",
                        height: "12px",
                        borderStyle: "solid",
                        borderWidth: "2px",
                        borderRadius: "20px",
                        borderColor: "black",
                      }}
                    ></div>
                  </div>
                </div>
              ))}
              <div className="d-flex">
                {this.state.accessType != "User" && (
                  <a
                    href={`/fa/panel/evaluations/list/results?id=${this.state.userId}`}
                  >
                    {" "}
                    {"رفتن به صفحه نتایج"}{" "}
                  </a>
                )}
                <a href="/fa/panel"> {"بازگشت به داشبورد"} </a>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (this.state.finishedAnswering == true) {
      return (
        <div className="screening-test" style={{ backgroundImage: "none" }}>
          {this.state.testResultsText[0]}
        </div>
      );
    }

    return (
      <div
        className={
          this.state.countryCode == "IR"
            ? "screening-test"
            : "screening-test-eng"
        }
        style={{ backgroundImage: "none" }}
      >
        <button
          onClick={() => this.nextQuestionNumberHandler()}
          className="pushButton-next-question"
        >
          <img src={arrowImage}></img>
        </button>
        <div className="test-container">
          <div className="question-number">
            {this.state.questionsCounter+1}/{this.state.questionsTotalNumber}
          </div>
          <div className="container-screening-question">
            <div className="screening-test-question">
              <p>
                {
                  this.state.questionsToShow[
                      this.state.questionsCounter
                  ]
                }
              </p>
            </div>
          </div>
          <div className="container-screening-answer">
            <button
              onClick={() => this.screeningAnswerHandler(3)}
              className="screening-answer-option mode-bg-2"
            >
              {"در اغلب مواقع"}
            </button>
            <button
              onClick={() => this.screeningAnswerHandler(2)}
              className="screening-answer-option mode-bg-2"
            >
              {"بسیاری اوقات"}
            </button>
            <button
              onClick={() => this.screeningAnswerHandler(1)}
              className="screening-answer-option mode-bg-2"
            >
              {"گاهی اوقات"}
            </button>
            <button
              onClick={() => this.screeningAnswerHandler(0)}
              className="screening-answer-option mode-bg-2"
            >
              {"هرگز یا به ندرت"}
            </button>
          </div>
        </div>
        <button
          onClick={() => this.previousQuestionNumberHandler()}
          className="pushButton-previous-question"
        >
          <img src={arrowImage}></img>
        </button>
      </div>
    );
  }
}

export default Adhd4;
